export function toPrecision(str: string | undefined, precision: number) {
  if (!str) return;
  const [start, end] = str.split('.');
  return `${start}.${(end ?? '').padEnd(precision, '0')}`;
}
